import {
  CatalogCategory,
  ICategory,
  TreeCatalogCategoryWithCategoryEntity,
} from '@core/models/product.model';
import { Tab, TreeTab } from '@core/models/tab-list.model';
import { Tree } from '@core/models/tree.model';

export function treeListToTreeTabList<Entity>({
  trees,
  entityToTab,
}: {
  trees: Tree<Entity>[];
  entityToTab: (entity: NoInfer<Entity>) => Tab;
}): TreeTab[] {
  return trees.map(tree => {
    const tab = entityToTab(tree);
    const { id, level, children } = tree;
    const treeTab: TreeTab = {
      ...tab,
      id,
      level,
      children: children ? treeListToTreeTabList({ trees: children, entityToTab }) : [],
    };
    return treeTab;
  });
}

export function linkTreeCatalogCategoryWithCategoryEntity(
  catalogCategories: CatalogCategory[],
  stores: ICategory[],
  level = 0,
): TreeCatalogCategoryWithCategoryEntity[] {
  return catalogCategories
    .map(catalogCategory => {
      return {
        id: catalogCategory.id,
        level,
        category: stores.find(store => store.id === catalogCategory.id),
        children: catalogCategory.children
          ? linkTreeCatalogCategoryWithCategoryEntity(catalogCategory.children, stores, level + 1)
          : [],
      };
    })
    .filter(
      treeCatalogCategory => treeCatalogCategory.category,
    ) as TreeCatalogCategoryWithCategoryEntity[];
}

export function toCatalogCategories(stores: string[]): CatalogCategory[] {
  return stores.map(store => ({
    id: store,
    children: [],
  }));
}

export function flattenTreeIds<Entity>(trees: Tree<Entity>[]): string[] {
  return trees.flatMap(tree => [tree.id, ...flattenTreeIds(tree.children ?? [])]);
}
